export default __webpack_public_path__ + "static/media/77093904441168741086979434845726990724347736724400506415443039242195830353.gif.49f289f2.mp4";